import LoginForm from "../../components/formLogin/LoginForm"
import { Container } from "../../design/Layout"

function Home() {
  return (
    <Container>
      <LoginForm />
    </Container>
  )
}

export default Home